export default "__VITE_ASSET__BLQwLwzT__"